<script lang="ts">
	import ScoringChart from './ScoringChart.svelte';
	import { t } from 'svelte-i18n';
	import { capitalize } from '@wiseed/wikit';
	import { ButtonTextPrimary } from '@wiseed/wikit';
	import { colors } from '@app/theme/colors';

	export let props: {
		valueEnergyTransition: string;
		valueSocial: string;
		valueGovernance: string;
	};
</script>

<div>
	<h3>{capitalize($t('operation.scoringESG.subtitle'))}</h3>
	<p>
		{capitalize($t('operation.scoringESG.description'))}
		<ButtonTextPrimary
			props={{
				label: capitalize($t('operation.scoringESG.learnMore')),
				href: 'https://aide.wiseed.com/hc/fr/articles/360020654939-Notre-scoring-ESG-pour-choisir-vos-investissements-Responsables',
				hrefTarget: 'blank'
			}}
		/>
	</p>
	<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
		<ScoringChart
			title={$t('scoringESG.energy-transition')}
			color={colors.charts.energyTransition}
			value={parseInt(props.valueEnergyTransition)}
		/>
		<ScoringChart
			title={$t('scoringESG.social')}
			color={colors.charts.health}
			value={parseInt(props.valueSocial)}
		/>
		<ScoringChart
			title={$t('scoringESG.governance')}
			color={colors.charts.secondary}
			value={parseInt(props.valueGovernance)}
		/>
	</div>
</div>

<style lang="postcss">
	div :global(.bx--chart-holder) {
		@apply w-11/12 !important;
	}
	div :global(.bx--cc--chart-svg .title) {
		@apply uppercase text-sm  !important;
	}
	div :global(.bx--cc--chart-svg .gauge-value-number) {
		@apply font-bold text-5xl !important;
	}
	div :global(.bx--cc--chart-svg .gauge-value-symbol) {
		@apply font-bold text-3xl !important;
	}
</style>
